const PRODUCT_DIMENSIONS = [
  "flightPath",
  "segmentFlightNumber",
  "segmentOperator",
  "departureDatetime",
  "arrivalDatetime",
  "flightLayoverDuration",
  "flightDuration",
  "upsellAmount",
  "upgradeAmount",
  "passengerId",
  "passengerListing",
  "passengerFfn",
  "bookingPrice",
  "bookingPeriod",
  "stars",
  "cancellationPeriod",
  "bookingId",
  "discount",
  "amenities",
  "aircraftType",
  "productTax",
  "passengerType",
  "segments",
  "miles",
  "refundAmount",
  "milesMoneyCombination",
  "offerId",
  "outboundPrice",
  "inboundPrice",
  "warning",
  "coupon",
  "ticketNumber",
  "travelType",
];

const PROMOTION_DIMENSIONS = [
  "promotionReturnDate",
  "promotionDepartureDate",
  "promotionName",
  "promotionDiscount",
  "promotionPrice",
  "promotionCabinType",
  "promotionTargeting",
  "promotionLoyaltyPrice",
  "promotionProduct",
  "promotionLabel",
  "promotionComponent",
  "promotionMilesAccumulation",
  "promotionTab",
  "usingMiles",
  "originRecommended",
  "destinationRecommended",
  "lowestFare",
  "suggestions",
  "adults",
  "children",
  "infants",
  "order",
  "promotionVariant",
];

export const isAvailable = (dimensionKey) => {
  return [...PRODUCT_DIMENSIONS, ...PROMOTION_DIMENSIONS].includes(dimensionKey);
};

const GA4_CUSTOM_PRODUCT_KEYS = {
  flightPath: "flight_path",
  segmentFlightNumber: "segment_flight_number",
  segmentOperator: "segment_operator",
  departureDatetime: "departure_datetime",
  arrivalDatetime: "arrival_datetime",
  flightLayoverDuration: "flight_layover_duration",
  flightDuration: "flight_duration",
  upsellAmount: "upsell_amount",
  upgradeAmount: "upgrade_amount",
  bookingPrice: "booking_price",
  bookingPeriod: "booking_period",
  stars: "stars",
  cancellationPeriod: "cancellation_period",
  bookingId: "booking_id",
  amenities: "amenities",
  aircraftType: "aircraft_type",
  productTax: "product_tax",
  passengerType: "passenger_type",
  passengerId: "passenger_id",
  passengerListing: "passenger_listing",
  passengerFfn: "passenger_ffn",
  segments: "segments",
  miles: "miles",
  refundAmount: "refund_amount",
  milesMoneyCombination: "miles_money_combination",
  offerId: "offer_id",
  outboundPrice: "outbound_price",
  inboundPrice: "inbound_price",
  warning: "warning",
  discount: "promo_discount",
  coupon: "coupon",
  ticketNumber: "ticket_number",
  originRecommended: "origin_recommended",
  destinationRecommended: "destination_recommended",
  lowestFare: "lowest_fare",
  suggestions: "suggestions",
  adults: "adults",
  children: "children",
  infants: "infants"
};

export const customsGA4Keys = (dimensionKey) => {
  const KEYS = {...GA4_CUSTOM_PRODUCT_KEYS, ...GA4_CUSTOM_PROMOTION_KEYS};
  return KEYS[dimensionKey] || dimensionKey;
};

const GA4_CUSTOM_PROMOTION_KEYS = {
  promotionReturnDate: "promotion_return_date",
  promotionDepartureDate: "promotion_departure_date",
  promotionName: "promotion",
  promotionDiscount: "promotion_discount",
  promotionPrice: "promotion_price",
  promotionLoyaltyPrice: "promotion_loyalty_price",
  promotionCabinType: "promotion_cabin",
  promotionTargeting: "promotion_targeting",
  promotionProduct: "promotion_product",
  promotionLabel: "promotion_label",
  promotionComponent: "promotion_component",
  promotionMilesAccumulation: "promotion_miles_accumulation",
  promotionTab: "promotion_tab",
  usingMiles: "using_miles",
  order: "order_id",
  promotionVariant: "promotion_variant",
};

const GA4_PRODUCT_KEY_MAP = {
  id: "item_id",
  name: "item_name",
  brand: "item_brand",
  variant: "item_variant",
  list: "item_list_name",
  position: "index",
};

export const productKeysGA4 = (dimensionKey) => {
  return GA4_PRODUCT_KEY_MAP[dimensionKey] || dimensionKey;
};

export const promotionKeysGA4 = (dimensionKey) => {
  return GA4_PROMOTION_KEYS[dimensionKey] || dimensionKey;
};

const GA4_PROMOTION_KEYS = {
  id: "promotion_id",
  name: "promotion_name",
  creative: "creative_name",
  promotionName: "promotion",
  promotionPrice: "price",
  position: "index",
};

export const GA4ProductKeyList = [
  "id",
  "name",
  "brand",
  "variant",
  "list",
  "position",
  "price",
  "quantity",
  "category",
  "item_category",
  "item_category2",
  "item_category3",
  "item_category4",
  "item_category5",
  "type",
];

export const GA4PromotionKeyList = ["id", "name", "creative", "position"];
